import React from 'react';
import { toast } from 'react-hot-toast';

export function ToastTest() {
  const showSuccessToast = () => {
    toast.success('This is a success message!');
  };

  const showErrorToast = () => {
    toast.error('This is an error message!');
  };

  const showInfoToast = () => {
    toast('This is an info message!');
  };

  return (
    <div className="p-4 flex flex-col space-y-4 max-w-md mx-auto mt-8">
      <h1 className="text-xl font-bold">Toast Testing</h1>
      
      <button
        onClick={showSuccessToast}
        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Show Success Toast
      </button>
      
      <button
        onClick={showErrorToast}
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
      >
        Show Error Toast
      </button>
      
      <button
        onClick={showInfoToast}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Show Info Toast
      </button>
    </div>
  );
} 